import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { SandboxBadge } from "@/components/site/Bits";

export const PaymentSuccess = () => {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [st, setSt] = useState<any>(null);
  const [tries, setTries] = useState(0);
  useEffect(() => {
    if (!sid || st?.payment_status === "paid" || tries > 10) return;
    const t = setTimeout(() => {
      api.get(`/payments/status/${sid}`).then((r) => setSt(r.data)).catch(() => {}).finally(() => setTries((n) => n + 1));
    }, tries ? 2000 : 0);
    return () => clearTimeout(t);
  }, [sid, st, tries]);
  const paid = st?.payment_status === "paid";
  const shipRef = params.get("kind") === "shipment" ? params.get("ref") : null;
  return (
    <div className="container-x flex justify-center py-24">
      <div className="card-lux w-full max-w-lg space-y-4 p-8 text-center" data-testid="payment-result">
        {st?.mode !== "live" && <SandboxBadge />}
        {paid ? <CheckCircle2 className="mx-auto text-emerald-600" size={40} /> : tries > 10 ? <XCircle className="mx-auto text-navy/40" size={40} /> : <Loader2 className="mx-auto animate-spin" size={40} />}
        <h1 className="text-3xl" data-testid="payment-status-title">{paid ? "Payment verified" : tries > 10 ? "Payment not yet verified" : "Verifying payment…"}</h1>
        <p className="text-sm text-navy/60">{paid ? (shipRef ? "Your payment was verified with the provider. A receipt email is on its way and our team will arrange pickup." : "Your payment was verified with the provider. Your booking status is updated separately by our team.") : "We only mark payments as paid after verification from the payment provider."}</p>
        {shipRef ? <Link to={`/shipping/track?ref=${shipRef}`} className="btn-navy" data-testid="payment-back-shipment">Track my shipment</Link> : <Link to="/my-bookings" className="btn-navy" data-testid="payment-back-bookings">Go to My Bookings</Link>}
      </div>
    </div>
  );
};

export const PaymentCancel = () => {
  const [params] = useSearchParams();
  return (
    <div className="container-x flex justify-center py-24">
      <div className="card-lux w-full max-w-lg space-y-4 p-8 text-center" data-testid="payment-cancelled">
        <XCircle className="mx-auto text-navy/40" size={40} />
        <h1 className="text-3xl">Payment cancelled</h1>
        <p className="text-sm text-navy/60">No payment was taken. You can try again from My Bookings.</p>
        <Link to={`/my-bookings?ref=${params.get("ref") || ""}`} className="btn-navy">Back to My Bookings</Link>
      </div>
    </div>
  );
};
